import 'babel-polyfill';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n'
import axios from 'axios';
import VueMoment from 'vue-moment';

import router from './router';
import store from './store';
import './api_service.js';
import './ebus.js';

import MenuDefault from './menu_default.js';
import MenuDetail from './menu_detail.js';
import MenuContact from './menu_contact.js';

import ErrorApi400 from './messages/errors/api400.js';
import ErrorApi401 from './messages/errors/api401.js';
import ErrorApi404 from './messages/errors/api404.js';
import ErrorApi403 from './messages/errors/api403.js';
import ErrorDefault from './messages/errors/default.js';
import ErrorModal from './messages/errors/modal.js';
import MessageSuccess from './messages/success.js';
import SuccessModal from './messages/successModal.js';

import AjaxLoader from './ajax_loader.js';

import {locale as cs} from './locale.cs.js' ;
import {locale as en} from './locale.en.js';

import {CONFIG} from './config.js';


Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(VueMoment);

const i18n = new VueI18n({
    locale: 'cs', // set locale
    messages: {
        cs: cs,
        en: en
    }
});

Vue.mixin({
    data: function() {
        return {
            get CUSTOMER() {
                return __CUSTOMER__;
            }
        }
    }
})

const app = new Vue({
    router,
    store,
    i18n,
    template: "#main",
    data: function() {
        return {
            menu: {component: 'menu-default'},
            runningAjaxRequests: 0,
            messages: []
        }
    },
    watch: {
        runningAjaxRequests: function(value) {
            // disable scrolling if loader is displayed
            document.body.style.overflow = value ? "hidden" : "visible";
        },
        '$route': function(value) {
            this.clearMessages();
        }
    },
    mounted() {
        var self = this;

        this.$ebus.$on("nav:login", () => this.login())
        this.$ebus.$on("nav:logout", () => this.logout())
        this.$ebus.$on("nav:contact", () => this.contact())
        this.$ebus.$on("modal:close", () => this.dropModalMessage())
        this.$ebus.$on("ajax:start", () => this.addRunningAjax())
        this.$ebus.$on("ajax:finished", () => this.finishRunningAjax())
        this.$ebus.$on("menu:update", (event) => this.updateMenu(event))
        this.$ebus.$on("menu:reset", () => this.resetMenu())
        this.$ebus.$on("msg:new", (event) => this.addMessage(event))
        this.$ebus.$on("msg:clear", () => this.clearMessages())
        this.$ebus.$on("msg:drop", (event) => this.dropMessage(event))

        // before a request is made show the progress and clear messages
        this.$api.interceptors.request.use(
            function(config) {
              self.$ebus.$emit('ajax:start');
              return config;
            },
            function(error) {
              self.$ebus.$emit('ajax:finished');
              return Promise.reject(error);
            });

        // before a response is returned hide progress
        this.$api.interceptors.response.use(
            function(response) {
              self.$ebus.$emit('ajax:finished');
              return response
            },
            function(error) {
              self.$ebus.$emit('ajax:finished');
              return Promise.reject(error);
            });

        if (localStorage.token) {
            store.commit('setToken', localStorage.token)
            store.commit('setTokenExpiresIn', localStorage.expires);
            var path = store.state.tokenExpiredBackwardRoute || CONFIG.afterLoginRoute;

            if (this.$route.fullPath == "/login" && !this.$store.getters.isTokenExpired ) {
                router.push({ path: "/list" });
            }

            if (router.currentRoute.meta != null && router.currentRoute.meta.requiresAuth == true && !this.$store.getters.isTokenExpired) {
                router.push({ path: path });
            }
        }
    },
    methods: {
        login: function() {
            store.commit('setToken', null)
            store.commit('setTokenExpiresIn', null);
            router.push({ path: '/login' })
        },
        list: function() {
            router.push({ path: '/list' })
        },
        contact: function() {
            router.push({ path: '/contact' })
        },
        logout: function() {
            store.commit('setToken', null)
            store.commit('setTokenExpiresIn', null);
            router.push({ path: '/login' })
        },
        addRunningAjax: function() {
            this.runningAjaxRequests++;
        },
        finishRunningAjax: function() {
            this.runningAjaxRequests--;
        },
        updateMenu: function(v) {
            this.menu = v;
        },
        resetMenu: function() {
            this.menu = {component: 'menu-default'};
        },
        clearMessages: function() {
            // drop all messages except persistent
            this.dropMessage(m => m.persistent !== true)
            // cancel persistency of persistent messages (they are persistent only in first cleaning)
            this.messages.forEach(m => m.persistent = false)
        },
        addMessage: function(message) {
            this.messages.push(message);
        },
        dropMessage: function(filter) {
            this.messages = this.messages.filter(function(m) { return !filter(m); });
        },
        dropModalMessage: function() {
            this.dropMessage(function(m) { return m.type == "error-modal"; });
        }
    }
}).$mount('#app')